// ImageUpload.js
import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './FileUploader.module.css'; // Create a CSS module for styling

const FileUploader = ({ onChange, value }) => {
    
  const [selectedImage, setSelectedImage] = useState(null);

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setSelectedImage(file);
    onChange(file);
  };
  useEffect(() => { 
    setSelectedImage(value);
  }, [value]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/*',
  });

  return (
    <div {...getRootProps()} className={`${styles.imageUpload} ${isDragActive ? styles.dragActive : ''}`}>
      <div className={styles.imageUploadContainer}>
       {!selectedImage && (
         <div className={styles.uploadText}>
           <p>{isDragActive ? 'Drop the image here' : 'Drag or Drop Image here'}</p>
           <span>.jpg, .jpeg, .png, .gif, .svg</span>
         </div>
       )}
        {selectedImage && (
          // support either a File/Blob object or a string URL
          (typeof selectedImage === 'string') ? (
            <img src={selectedImage} alt="Selected" />
          ) : (
            <img src={URL.createObjectURL(selectedImage)} alt="Selected" />
          )
        )}
      </div>
      <input {...getInputProps()} />
    </div>
  );
};

export default FileUploader;
